<div id="incremental-input" (mousewheel)="onScroll($event)" class="overIncrement"
  [ngClass]="{'with-bg': withBackground,'without-bg': !withBackground}">
  <ng-container *ngIf="!withBackground; else elseTemplate">
    <mat-form-field [ngClass]="{'invalidC': !invalid}" id="incrementalInput">
      <div class="increment-buttons-container" style="float: right; display: flex">
        <input matInput currencyMask [maxlength]="maxlength" (keyup)="keyUpped()" (keypress)="keyPressed($event)"
          (paste)="onPaste($event)" (focus)="onFocus()" (blur)="onBlur()" [placeholder]="labelText"
          [disabled]="isDisabled" [options]="options" [(ngModel)]="value">
        <div class="button decrement" (click)="increment()" *ngIf="!isDisabled">
          <i class="material-icons plus" [ngClass]="{'invalid': !invalid}">add</i>
        </div>
        <div class="button increment" (click)="decrement()" *ngIf="!isDisabled">
          <i class="material-icons minus" [ngClass]="{'invalid': !invalid}">-</i>
        </div>
      </div>
    </mat-form-field>
  </ng-container>
  <ng-template #elseTemplate>
    <mat-form-field appearance="fill">
      <mat-label>{{labelText}}</mat-label>
      <input matInput currencyMask [maxlength]="maxlength" (keyup)="keyUpped()" (keypress)="keyPressed($event)"
        (paste)="onPaste($event)" (focus)="onFocus()" (blur)="onBlur()" [disabled]="isDisabled" [options]="options"
        [(ngModel)]="value">
      <mat-icon matPrefix (click)="decrement()" *ngIf="!isDisabled">remove</mat-icon>
      <mat-icon matSuffix (click)="increment()" *ngIf="!isDisabled">add</mat-icon>
    </mat-form-field>
  </ng-template>
</div>
